<template>
  <el-dialog
    :visible="visible"
    title="Оплачено"
    append-to-body
    custom-class="payment-success"
    @close="closeHandler"
  >
    <h2 class="payment-success__title">
      Спасибо за оплату обучения.
    </h2>
    <p class="payment-success__message">
      В ближайшее время на Ваш электронный адрес, указанный в Анкете, мы направим информацию о
      доступе на Платформу
    </p>
    <el-button type="success" class="payment-success__button" @click="$router.push('/')"
      >Вернуться на главную страницу</el-button
    >
  </el-dialog>
</template>

<script>
export default {
  name: 'PaymentModalSuccess',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    closeHandler() {
      this.$emit('update:visible', false)
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.payment-success {
  width: 480px !important;

  @include sm-and-down {
    width: 100% !important;
  }

  &__title {
    font-size: 30px;
    text-align: center;
    letter-spacing: 0.35px;
    color: $deepdark;
    font-weight: 300;
    margin-bottom: 24px;
  }

  &__message {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: $deepdark;
    margin-bottom: 32px;
  }

  &__button {
    font-size: 18px !important;
    display: block !important;
    margin: 0 auto !important;

    @include sm-and-down {
      margin-left: 0 !important;
      margin-bottom: 12px;
      width: 100%;
    }
  }

  .el-dialog {
    &__title {
      text-transform: uppercase;
    }

    &__header {
      padding: 42px 18px 24px;
    }

    &__body {
      padding: 0 24px 24px;

      @include md-and-down {
        padding: 0 16px 16px;
      }
    }
  }
}
</style>
